
const FooterIcons: React.FC = () => {

return (
    <div className="flex justify-center space-x-4 mt-4">
        {/* Instagram */}
        <a
            href="https://instagram.com"
            target="_blank"
            rel="noreferrer"
            className="text-white hover:text-pink-500"
        >
            <i className="fab fa-instagram text-xl"></i>
        </a>
        {/* Facebook */}
        <a
            href="https://facebook.com"
            target="_blank"
            rel="noreferrer"
            className="text-white hover:text-blue-600"
        >
            <i className="fab fa-facebook text-xl"></i>
        </a>
        {/* Help and Support */}
        <a
            href="/help-support"
            className="text-white hover:text-gray-400"
        >
            <i className="fas fa-life-ring text-xl"></i>
        </a>
        {/* YouTube */}
        <a
            href="https://youtube.com"
            target="_blank"
            rel="noreferrer"
            className="text-white hover:text-red-600"
        >
            <i className="fab fa-youtube text-xl"></i>
        </a>
        {/* TikTok */}
        <a
            href="https://tiktok.com"
            target="_blank"
            rel="noreferrer"
            className="text-white hover:text-black"
        >
            <i className="fab fa-tiktok text-xl"></i>
        </a>
    </div>
    );
};
export default FooterIcons;
